import { nanoid } from 'nanoid';
import { POLL_CARD_SORTING_CATEGORY, POLL_CARD_SORTING_CATEGORY_ANSWER } from '../../../../../poll';
import { assignProperties } from '../../../../schemaUtils';
import { config } from './CardSortingCategoryPoll.config';

export function generateQuestion(
  answers: POLL_CARD_SORTING_CATEGORY_ANSWER[],
  overrides: Partial<POLL_CARD_SORTING_CATEGORY['data']> = {},
): POLL_CARD_SORTING_CATEGORY {
  return {
    id: nanoid(10),
    data: assignProperties<POLL_CARD_SORTING_CATEGORY['data']>(
      {
        type: config.name,
        text: '',
        requiresAnswer: true,
        randomizeAnswers: false,
        exclusiveQuestion: false,
        cardSortingType: 'closed',
        cardSortingAllowUncomplete: false,
        categoryForUnsortedCards: false,
        logicRules: [],
        answers,
      },
      overrides,
    ),
  };
}

export function generateAnswer(
  overrides: Partial<POLL_CARD_SORTING_CATEGORY_ANSWER> = {},
): POLL_CARD_SORTING_CATEGORY_ANSWER {
  return {
    id: nanoid(10),
    text: '',
    ...overrides,
  };
}
